<ng-container *ngIf="!this.isLoading; else whydonateLoader">
	<div ngClass="p-t-m" fxLayout="column">
		<mat-card
			class="m-r-s m-l-s"
			class="mat-elevation-z0 h-100">
			<mat-card-content
				fxLayout="row"
				fxLayout.xs="column"
				fxLayoutAlign="space-between center"
				fxLayoutAlign.xs="start start">
				<!-- Button on the left -->
				<div class="m-l-s">
					<mat-card-title
						i18n="@@embed_embedDonation_title">
						Embed donation Widget to your website
					</mat-card-title>
				</div>
				<div>
					<button
						mat-flat-button
						class="button-button-style"
						(click)="redirectToCreate()"
						color="accent"
						[disabled]="buttonDisable">
						<span i18n="@@widget_button_create_widget"> Create Widget </span>
					</button>
				</div>
				<!-- h1 on the right -->
			</mat-card-content>
		</mat-card>
		<div class="h-100" class="m-l-s p-l-m" [hidden]="!buttonDisable">
			<div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="1%">
				<div>
					<img
						src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/infoOrange/public" />
				</div>
				<div ngClass="p-b-xxs">
					<span i18n="@@widget_create_fundraiser_page_infotip">Please create a
						fundraiser before creating a widget.</span>
				</div>
			</div>
		</div>
	</div>

	<div class="table-container" [hidden]="isLoading">
		<table
			mat-table
			multiTemplateDataRows
			[dataSource]="dataSource"
			fxFlex.xs="100%"
			fxFlex="100%"
			fxFlexFill>
			<!-- Preview Column -->
			<ng-container matColumnDef="preview">
				<th
					mat-header-cell
					*matHeaderCellDef
					[ngClass]="'min-w-100px'"
					i18n="@@button_preview">
					Preview
				</th>
				<td
					mat-cell
					*matCellDef="let element"
					[ngClass]="'min-w-100px'"
					[style.width.px]="230"
					[style.height.px]="230">
					<div
						fxLayout="row"
						fxLayoutAlign="start center"
						[style.font-size.px]="16"
						[style.font-smooth]="'always'"
						[style.marginRight.px]="10"
						[style.marginTop.px]="10"
						[style.marginBottom.px]="10">
						<img src="{{element.preview}}" [style.width.px]="170" />
					</div>
				</td>
			</ng-container>

			<!-- Fundraiser Name Column -->
			<ng-container matColumnDef="fundraiserName">
				<th
					mat-header-cell
					*matHeaderCellDef
					[ngClass]="'min-w-100px'"
					[ngStyle]="{ 'width': '200px' }"
					i18n="@@widget_table_heading_fundraiser_name">
					Fundraiser Name
				</th>
				<td
					mat-cell
					*matCellDef="let element"
					[ngClass]="'min-w-100px'"
					[ngStyle]="{ 'width': '200px' }"
					[style.marginRight.px]="20">
					{{element.fundraiserName}}
				</td>
			</ng-container>

			<!-- HTML Code Column -->
			<ng-container matColumnDef="htmlCode">
				<th
					mat-header-cell
					*matHeaderCellDef
					i18n="@@widget_table_heading_html_code">
					HTML Code
				</th>
				<td
					mat-cell
					*matCellDef="let element;"
					[style.min-width.px]="320"
					[style.max-width.px]="320">
					<div [style.marginRight.px]="10">
						<div
							class="grey-bg mat-subtitle-2"
							ngClass="p-l-s p-t-xs p-b-xs"
							fxLayout="column">
							<!-- Ensure full height -->

							<div
								fxFlex
								[style.marginLeft.px]="10"
								[style.marginRight.px]="10"
								[style.marginTop.px]="10"
								[style.marginBottom.px]="10"
								[style.min-width.px]="310">
								{{ truncateText(element.htmlCode, 200) }}
							</div>

							<div fxLayout="row" fxLayoutAlign="end center">
								<div fxFlex></div>
								<!-- This div takes up remaining space -->
								<button
									(mousedown)="onMouseDown(element.shortcode)"
									(mouseup)="onMouseUp(element.shortcode)"
									(touchstart)="onMouseDown(element.shortcode)"
									(touchend)="onMouseUp(element.shortcode)"
									(click)="copyHtmlCode(element.shortcode, element.successUrl, element.failureUrl)"
									[style.color]="buttonStates[element.shortcode] ? '#51d171' : null"
									class="copyLink hover-class"
									matTooltip="{{ matTooltip }}"
									mat-icon-button>
									<mat-icon size="3x">content_copy</mat-icon>
								</button>
							</div>
						</div>
					</div>
					<!-- <div fxLayout="column" class="section-background-grey">
					  <div fxLayoutAlign="space-between center" class="mat-elevation-z0">
						  {{element.htmlCode}}
					  </div>
  
					  <div
						  fxLayout="row"
						  fxLayoutAlign="flex-end center"
						  class="button-container"
						  [ngStyle]="{'margin-top': '5px'}"
					  >
						  <button
							  mat-icon-button
							  (click)="copyHtmlCode(element.shortcode)"
							  class="copyLink hover-class"
						  >
							  <mat-icon size="3x">content_copy</mat-icon>
						  </button>
					  </div>
				  </div> -->
				</td>
			</ng-container>

			<!-- Action Column -->
			<ng-container matColumnDef="action">
				<th mat-header-cell *matHeaderCellDef>
					<div [style.marginLeft.px]="25" i18n="@@widget_table_heading_action">
						Action
					</div>
				</th>
				<td mat-cell *matCellDef="let element">
					<div
						[style.marginLeft.px]="10"
						[style.marginTop.px]="10"
						[style.marginBottom.px]="10"
						[style.min-width.px]="100"
						fxLayout="row"
						fxLayoutAlign="start center"
						fxLayoutGap="8px">
						<!-- <button
						  class="download"
						  mat-stroked-button
						  color="accent"
						  (click)="redirectToEdit(element.shortcode)"
					  >
						  Edit
					  </button> -->
						<!-- <button (click)="copyHtmlCode(element.shortcode)">
						  Copy HTML Code
					  </button> -->
						<div fxFlexOffset="10">
							<button
								matTooltip="{{ matTooltipEditWidget }}"
								mat-icon-button
								(click)="redirectToEdit(element.shortcode)">
								<img
									height="28px"
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/editSmall/public" />
							</button>
							<!-- <button
						  class="download"
						  mat-stroked-button
						  color="accent"
						  (click)="deleteStyle(element.shortcode)"
					  >
						  Remove
					  </button> -->
							<!-- <button mat-icon-button (click)="deleteStyle(element.shortcode)"> -->
							<button
								mat-icon-button
								matTooltip="{{ matTooltipDeleteWidget }}"
								(click)="openDeleteFundraiserDialog(element.shortcode)">
								<img
									height="28px"
									src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/deleteSmall/public" />
							</button>
						</div>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	</div>
	<div
		*ngIf="this.dataSource.length <= 0 && isLoading == false"
		class="p-t-xl p-b-xl"
		fxLayout="row"
		fxLayoutAlign="center center">
		<div>
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/balanceNoData/public" />
		</div>
		<div ngClass="p-l-m">
			<mat-label
				class="mat-headline-6 m-0"
				i18n="@@donationSummary_donation_noRecordsTitle">No data <br />to
				show</mat-label>
		</div>
	</div>
	<div [hidden]="!isLoading">
		<ng-container *ngIf="isLoading; else whydonateLoader">
			<app-page-loader></app-page-loader>
		</ng-container>
	</div>
</ng-container>
<!-- Page loader / whydonate loader -->
<ng-template #whydonateLoader>
	<app-page-loader></app-page-loader>
</ng-template>
